//
// locales/vanilla/ar.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/ar.json';
import localeData from 'react-intl/locale-data/ar.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
